module.exports = __webpack_public_path__ + "static/media/4.57e6bd1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/4.png
// module id = 763
// module chunks = 0